'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerSecondaryImageContainer = renderWithRef('BannerSecondaryImageContainer', null, (r, a)=>{
    let { children: o } = r;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: [
            'swan-banner-image-container',
            'swan-banner-secondary-image-container'
        ],
        props: r,
        children: o
    });
});

export { BannerSecondaryImageContainer };
